module.exports = __webpack_public_path__ + "img/cxllx.20087af3.jpg";